<template>
  <div class="mt-2">
    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbytimeOptions && !loading">
            <apexchart
              ref="reportuserbytime"
              type="area"
              height="350"
              :options="reportuserbytimeOptions"
              :series="reportuserbytimeSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import DashboardGraphLoading from '../analytics/DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  props: ['value', 'date', 'beaconSelect'],
  data() {
    return {
      loading: true,
      reportuserbytimeSeries: null,
      reportuserbytimeOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('Message')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      var response = await api.reportUserByTimeBeaconsList({
        pageid: this.selectedBot.pageid,
        params: {
          from_date: dayjs(this.date.start).format('YYYY-MM-DD'),
          to_date: dayjs(this.date.end).format('YYYY-MM-DD')
        }
      })

      await this.$nextTick()
      var data = []
      var raw = []
      if (this.beaconSelect) {
        raw = response.result.filter(item => item.hwid === this.beaconSelect.beacon_id)[0]
      }
      if (typeof raw === 'undefined') {
        this.loading = false
        this.reportuserbytimeSeries = [
          { name: this.$t('Information received over time'), data: data }
        ]
      } else {
        let today = dayjs()

        for (let index = 0; index <= 23; index++) {
          const element = raw[`time_${index}`]
          let date = today.format(`YYYY-MM-DDT${index.toString()}:00`)
          const tzOffset = new Date().getTimezoneOffset()
          data.push([
            dayjs(date)
              .utcOffset(0, true)
              .valueOf(),
            parseInt(element)
          ])
        }

        this.reportuserbytimeSeries = [
          { name: this.$t('Information received over time'), data: data }
        ]
        var max = 0
        if (data && data.length > 0) {
          max = data.reduce((acc, val) => {
            acc = acc === undefined || val[1] > acc ? val[1] : acc
            return acc
          }, [])
        }

        if (this.$refs.reportuserbytime) {
          this.$refs.reportuserbytime.updateOptions({
            yaxis: {
              max: max + 5
            }
          })
        }
        this.$emit('onLoaded', { loading: false, data: this.reportuserbytimeSeries })
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/beacon/ReportUserByTime.vue